import {
  activityServiceOrderEnum,
  statesServiceOrderEnum
} from "../../../constants/enums";

export const filterStatesByOrderState = (
  stateList,
  isNew,
  state_id,
  activityId,
  setState
) => {
  let filteredStates = [];

  if (isNew) {
    filteredStates = stateList.filter((state) => state.order_state_id === 1);
    setState(filteredStates);
    return;
  }

  if (activityId === activityServiceOrderEnum.CorrectiveMaintenance) {
    if (state_id === statesServiceOrderEnum.ServiceOrderCreation) {
      filteredStates = stateList.filter((state) =>
        [
          statesServiceOrderEnum.ServiceOrderCreation,
          statesServiceOrderEnum.DeliveryOSClosure,
          statesServiceOrderEnum.Diagnosis,
          statesServiceOrderEnum.EngineerinReport
        ].includes(state.order_state_id)
      );
    } else if (state_id === statesServiceOrderEnum.Diagnosis) {
      filteredStates = stateList.filter((state) =>
        [
          statesServiceOrderEnum.Diagnosis,
          statesServiceOrderEnum.Repair
        ].includes(state.order_state_id)
      );
    } else if (state_id === statesServiceOrderEnum.EngineerinReport) {
      filteredStates = stateList.filter((state) =>
        [
          statesServiceOrderEnum.EngineerinReport,
          statesServiceOrderEnum.DeliveryOSClosure
        ].includes(state.order_state_id)
      );
    } else if (state_id === statesServiceOrderEnum.Repair) {
      filteredStates = stateList.filter((state) =>
        [
          statesServiceOrderEnum.Repair,
          statesServiceOrderEnum.Testing,
          statesServiceOrderEnum.EngineerinReport
        ].includes(state.order_state_id)
      );
    } else if (state_id === statesServiceOrderEnum.Testing) {
      filteredStates = stateList.filter((state) =>
        [
          statesServiceOrderEnum.Testing,
          statesServiceOrderEnum.EngineerinReport,
          statesServiceOrderEnum.DeliveryOSClosure
        ].includes(state.order_state_id)
      );
    }
    if (state_id === statesServiceOrderEnum.DeliveryOSClosure) {
      filteredStates = stateList.filter((state) =>
        [statesServiceOrderEnum.DeliveryOSClosure].includes(
          state.order_state_id
        )
      );
    }
    if (state_id === statesServiceOrderEnum.Completed) {
      filteredStates = stateList.filter((state) =>
        [statesServiceOrderEnum.Completed].includes(state.order_state_id)
      );
    }
  } else if (activityId === activityServiceOrderEnum.Setup) {
    if (state_id === statesServiceOrderEnum.ServiceOrderCreation) {
      filteredStates = stateList.filter((state) =>
        [
          statesServiceOrderEnum.ServiceOrderCreation,
          statesServiceOrderEnum.DocumentaryTechnicalPreparation,
          statesServiceOrderEnum.DeliveryOSClosure
        ].includes(state.order_state_id)
      );
      const order = [
        statesServiceOrderEnum.ServiceOrderCreation,
        statesServiceOrderEnum.DocumentaryTechnicalPreparation,
        statesServiceOrderEnum.DeliveryOSClosure
      ];
      filteredStates.sort(
        (a, b) =>
          order.indexOf(a.order_state_id) - order.indexOf(b.order_state_id)
      );
    } else if (state_id === statesServiceOrderEnum.Return) {
      filteredStates = stateList.filter((state) =>
        [
          statesServiceOrderEnum.Return,
          statesServiceOrderEnum.DeliveryOSClosure
        ].includes(state.order_state_id)
      );

      const order = [
        statesServiceOrderEnum.Return,
        statesServiceOrderEnum.DocumentaryTechnicalPreparation,
        statesServiceOrderEnum.DeliveryOSClosure
      ];
      filteredStates.sort(
        (a, b) =>
          order.indexOf(a.order_state_id) - order.indexOf(b.order_state_id)
      );
    }
    if (state_id === statesServiceOrderEnum.DocumentaryTechnicalPreparation) {
      filteredStates = stateList.filter((state) =>
        [
          statesServiceOrderEnum.DocumentaryTechnicalPreparation,
          statesServiceOrderEnum.PhysicalPreparation
        ].includes(state.order_state_id)
      );
    }
    if (state_id === statesServiceOrderEnum.PhysicalPreparation) {
      filteredStates = stateList.filter((state) =>
        [
          statesServiceOrderEnum.PhysicalPreparation,
          statesServiceOrderEnum.Return,
          statesServiceOrderEnum.DeliveryOSClosure
        ].includes(state.order_state_id)
      );
    }
    if (state_id === statesServiceOrderEnum.DeliveryOSClosure) {
      filteredStates = stateList.filter((state) =>
        [statesServiceOrderEnum.DeliveryOSClosure].includes(
          state.order_state_id
        )
      );
    }
    if (state_id === statesServiceOrderEnum.Completed) {
      filteredStates = stateList.filter((state) =>
        [statesServiceOrderEnum.Completed].includes(state.order_state_id)
      );
    }
  } else if (activityId === activityServiceOrderEnum.TechnicalAssist) {
    if (state_id === statesServiceOrderEnum.ServiceOrderCreation) {
      filteredStates = stateList.filter((state) =>
        [
          statesServiceOrderEnum.ServiceOrderCreation,
          statesServiceOrderEnum.TechnicalActivity,
          statesServiceOrderEnum.DeliveryOSClosure
        ].includes(state.order_state_id)
      );
    } else if (state_id === statesServiceOrderEnum.TechnicalActivity) {
      filteredStates = stateList.filter((state) =>
        [
          statesServiceOrderEnum.TechnicalActivity,
          statesServiceOrderEnum.DeliveryOSClosure
        ].includes(state.order_state_id)
      );
    } else if (state_id === statesServiceOrderEnum.DeliveryOSClosure) {
      filteredStates = stateList.filter((state) =>
        [statesServiceOrderEnum.DeliveryOSClosure].includes(
          state.order_state_id
        )
      );
    }
    if (state_id === statesServiceOrderEnum.Completed) {
      filteredStates = stateList.filter((state) =>
        [statesServiceOrderEnum.Completed].includes(state.order_state_id)
      );
    }
  } else if (
    activityId === activityServiceOrderEnum.ConsumablesAdjustment ||
    activityId === activityServiceOrderEnum.PreventiveMaintenance ||
    activityId === activityServiceOrderEnum.AcademicActivity ||
    activityId === activityServiceOrderEnum.PreInstallation ||
    activityId === activityServiceOrderEnum.Installation ||
    activityId === activityServiceOrderEnum.SoftwareUpdate ||
    activityId === activityServiceOrderEnum.Training
  ) {
    if (state_id === statesServiceOrderEnum.ServiceOrderCreation) {
      filteredStates = stateList.filter((state) =>
        [
          statesServiceOrderEnum.ServiceOrderCreation,
          statesServiceOrderEnum.TechnicalActivity,
          statesServiceOrderEnum.DeliveryOSClosure
        ].includes(state.order_state_id)
      );
    } else if (state_id === statesServiceOrderEnum.TechnicalActivity) {
      filteredStates = stateList.filter((state) =>
        [
          statesServiceOrderEnum.TechnicalActivity,
          statesServiceOrderEnum.EngineerinReport
        ].includes(state.order_state_id)
      );
    } else if (state_id === statesServiceOrderEnum.EngineerinReport) {
      filteredStates = stateList.filter((state) =>
        [
          statesServiceOrderEnum.EngineerinReport,
          statesServiceOrderEnum.DeliveryOSClosure
        ].includes(state.order_state_id)
      );
    } else if (state_id === statesServiceOrderEnum.DeliveryOSClosure) {
      filteredStates = stateList.filter((state) =>
        [statesServiceOrderEnum.DeliveryOSClosure].includes(
          state.order_state_id
        )
      );
    }
    if (state_id === statesServiceOrderEnum.Completed) {
      filteredStates = stateList.filter((state) =>
        [statesServiceOrderEnum.Completed].includes(state.order_state_id)
      );
    }
  } else if (activityId === activityServiceOrderEnum.PredictiveVisit) {
    if (state_id === statesServiceOrderEnum.ServiceOrderCreation) {
      filteredStates = stateList.filter((state) =>
        [
          statesServiceOrderEnum.ServiceOrderCreation,
          statesServiceOrderEnum.TechnicalActivity,
          statesServiceOrderEnum.DeliveryOSClosure
        ].includes(state.order_state_id)
      );
    } else if (state_id === statesServiceOrderEnum.TechnicalActivity) {
      filteredStates = stateList.filter((state) =>
        [
          statesServiceOrderEnum.TechnicalActivity,
          statesServiceOrderEnum.DeliveryOSClosure
        ].includes(state.order_state_id)
      );
    } else if (state_id === statesServiceOrderEnum.DeliveryOSClosure) {
      filteredStates = stateList.filter((state) =>
        [statesServiceOrderEnum.DeliveryOSClosure].includes(
          state.order_state_id
        )
      );
    }
    if (state_id === statesServiceOrderEnum.Completed) {
      filteredStates = stateList.filter((state) =>
        [statesServiceOrderEnum.Completed].includes(state.order_state_id)
      );
    }
  }

  setState(filteredStates);
};
